export const getUniqueArrayItems = <T>(arr: T[]): T[] => Array.from(new Set(arr));
